export const EventAction = {
  BUSINESSES_CLICKED_FROM_FOOTER: 'click',
} as const;
